import { SetState } from 'zustand';
import type { InventorizeMeterStore } from '../../useStore';

export interface FloorplanStepForm {
  floorplanPosition: {
    lat: number;
    lng: number;
  };
}

const INITIAL_STATE: FloorplanStepForm = {
  floorplanPosition: {
    lat: 0,
    lng: 0,
  },
};

export type FloorplanStepSlice = FloorplanStepForm & {
  resetFloorplanStepSlice: () => void;
  setFloorplanStepValues: (values: FloorplanStepForm) => void;
};

export const createFloorplanStepSlice = (set: SetState<InventorizeMeterStore>): FloorplanStepSlice => ({
  ...INITIAL_STATE,
  resetFloorplanStepSlice: () => set(INITIAL_STATE),
  setFloorplanStepValues: (values: FloorplanStepForm) => set(values),
});
